import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationServiceMetaGet = {
    path: "/template/services/meta",
    method: ERouteHttpVerb.GET
};
export { routeLocationServiceMetaGet };
